/**
 * Menu and HUD clicks. Phaser field taps stay on the canvas and are skipped.
 * Uses the duel click sample (or its synth fallback) at a quieter gain.
 */

import { DuelSfx } from './DuelSfx'

const DEBOUNCE_MS = 90

const CONTROL_SELECTOR = [
  'button',
  'a[href]',
  'summary',
  'select',
  '[role="button"]',
  '[role="tab"]',
  '[role="switch"]',
  '[role="menuitem"]',
  'input[type="button"]',
  'input[type="submit"]',
  'input[type="reset"]',
  'input[type="checkbox"]',
  'input[type="radio"]',
  'input[type="file"]',
].join(',')

let lastAt = 0
let installed = false

function isDisabled(el: Element): boolean {
  if (el.hasAttribute('disabled')) return true
  if (el.getAttribute('aria-disabled') === 'true') return true
  if (el instanceof HTMLInputElement || el instanceof HTMLButtonElement) {
    return el.disabled
  }
  return false
}

function findControl(start: EventTarget | null): Element | null {
  let el: Element | null = start instanceof Element ? start : null
  while (el) {
    if (el.closest('[data-no-ui-sfx]')) return null
    if (el.matches(CONTROL_SELECTOR) && !isDisabled(el)) return el
    el = el.parentElement
  }
  return null
}

function onClick(event: MouseEvent): void {
  if (event.button !== 0) return
  const target = event.target
  if (target instanceof Element) {
    const canvas = target.closest('canvas')
    if (canvas && !canvas.closest(CONTROL_SELECTOR)) return
  }
  const control = findControl(target)
  if (!control) return
  const now = performance.now()
  if (now - lastAt < DEBOUNCE_MS) return
  lastAt = now
  DuelSfx.prime()
  DuelSfx.play('click', 0.55)
}

/**
 * Capture-phase listener on the document. Safe to call more than once.
 */
export function installUiSfx(): void {
  if (installed || typeof document === 'undefined') return
  installed = true
  document.addEventListener('click', onClick, true)
}
